import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-boolean-questiontype',
  templateUrl: './boolean.questiontype.component.html'
})
export class BooleanQuestiontypeComponent implements OnInit, OnDestroy {
  @Output() onChange = new EventEmitter<any>();
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  value:any=undefined;
  formSegment:FormGroup;
  private listener:any;

  public getValue():object {
    var result={};
    switch(this.formSegment.value['item']) {
      case "1":
        result[this.questionid]=true;
        break;
      case "0":
        result[this.questionid]=false;
        break;
      default:
        result[this.questionid]=undefined;
        break;
    }
    return result;
  }

  isValid():boolean {
    if(this.required) {
      return (this.formSegment.value['item']=='1' || this.formSegment.value['item']=='0')
    }
    return true;
  }
  validate():boolean {
    this.formSegment.controls['item'].markAsTouched();
    return this.isValid();
  }

  get formError():string {
    if(this.required) {
      if((this.formSegment.controls['item'].dirty || this.formSegment.controls['item'].touched) && !this.isValid()) {
        return 'You must answer this question, yes or no.';
      }
    }
    return '';
  }

  ngOnInit() {
    var init={};
    init['item']=new FormControl();

    this.formSegment=new FormGroup(init);

    if ((typeof this.value)=='boolean') {
      init['item'].setValue(!!this.value?'1':'0');
    } else {
      init['item'].setValue('');
    }

    this.listener=this.formSegment.valueChanges.subscribe((obj)=>{
      switch(obj['item']) {
        case "1":
          this.onChange.emit(true);
          break;
        case "0":
          this.onChange.emit(false);
          break;
        default:
          this.onChange.emit(undefined);
          break;
      }
    });
  }

  ngOnDestroy() {
    this.listener.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/boolean.questiontype.component.ts